import { isAppHttpError } from "@/lib/api";

export function entitlementBlockedMessage(...errors: unknown[]): string | null {
  for (const error of errors) {
    if (isAppHttpError(error) && error.status === 403) {
      return error.message || "Warranty expired. Data access is no longer available for this device.";
    }
  }
  return null;
}
